import { render, staticRenderFns } from "./CreatePassenger.vue?vue&type=template&id=68500422&scoped=true"
import script from "./CreatePassenger.vue?vue&type=script&lang=js"
export * from "./CreatePassenger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68500422",
  null
  
)

export default component.exports